// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a.no-link-style{text-decoration:none;color:inherit}\n", ""]);
// Exports
module.exports = exports;
